import React, { ReactNode, useMemo } from 'react';

import './styles.scss';

interface Props {
    type: 'danger';
    children: ReactNode;
    className?: string;
}

export const Label = ({ type, children, className = '' }: Props) => {
    const classNameByType = useMemo(() => {
        switch (type) {
            case 'danger':
                return 'app-label--danger';
            default:
                return '';
        }
    }, [type]);
    return <div className={`app-label ${classNameByType} ${className}`}>{children}</div>;
};
